'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$53() {
  this.biZ = null;
  this.bj0 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$53 as $c_Lpresto_PrestoRouter$$anon$53 };
$p = $c_Lpresto_PrestoRouter$$anon$53.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$53;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$53() {
}
export { $h_Lpresto_PrestoRouter$$anon$53 as $h_Lpresto_PrestoRouter$$anon$53 };
$h_Lpresto_PrestoRouter$$anon$53.prototype = $p;
$p.bY = (function() {
  if ((!this.bj0)) {
    this.biZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bj0 = true;
  }
  return this.biZ;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_PrestoRouter$$anon$53 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$53, "presto.PrestoRouter$$anon$53", ({
  Ou: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$53 as $d_Lpresto_PrestoRouter$$anon$53 };
//# sourceMappingURL=presto.-Presto-Router$$anon$53.js.map
